export const costs = [
  'Sleepless nights searching for ways to translate complex renewable energy concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how renewable energy connects to their careers or lives.",
  "Awkward silences when a student asks how to size a solar panel or which battery type to use and you don't have a clear answer.",
  'Weekends lost building lesson plans, technical projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach hybrid systems, biogas, or geothermal applications without adequate resources.',
];
